import React from 'react';
import Select from '@/components/ui/Select';
import FormItem from '@/components/ui/FormItem';
import { useWorker } from '@/components/views/Resolution886/components/Form/_hooks/useWorker';
import type { FormItemProps } from '@/components/views/Resolution886/types';

export function WorkersFormItem({
	fieldName = '',
	required = true,
	disabled = false
}: Readonly<FormItemProps>): JSX.Element {
	const {
		items,
		workerId,
		isLoadingCreatingWorker,
		addItem,
		handleInputChange,
		handleOnChange,
		handleOnClear,
		handleSearch
	} = useWorker({
		fieldName
	});

	return (
		<FormItem label="Worker(s) name" name={fieldName} requiredMessage="Please select a worker" required={required}>
			<Select.Multiple
				isAdd={!disabled}
				showSearch
				options={items}
				value={workerId}
				addItem={addItem}
				textButton="Add item"
				onClear={handleOnClear}
				onChange={handleOnChange}
				placeholder="Select a worker"
				onInputChange={handleInputChange}
				placeholderInput="Please enter a worker"
				onSearch={handleSearch}
				loading={isLoadingCreatingWorker}
			/>
		</FormItem>
	);
}
